






































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Multiselect from 'vue-multiselect'
import Icon from '@/components/Icon.vue'
import '@/components/inputsV2/styles/MultiSelectV2.scss'

@Component({
  components: {
    Icon,
    Multiselect
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    },
    showSelectedCounter: {
      type: Boolean,
      default: false
    },
    /** Use only if you need to select all options in one click.
     *  It does not add 'all' option to output
     * */
    selectAll: {
      type: Boolean,
      default: false
    },
    value: {}
  }
})
export default class MultiSelectV2 extends Vue {
  direction: string = 'top'
  localValue: any[] = []

  get localOptions () {
    if (this.$props.selectAll) {
      return [
        {
          key: 'all',
          value: 'all',
          content: 'All'
        },
        ...this.$props.options
      ]
    }
    return this.$props.options
  }

  get taggableLocalValue () {
    return this.localValue.filter(option => option.value !== 'all')
  }

  mounted () {
    this.$watch('value', (newVal: any) => {
      if (!newVal || newVal.length <= 0) {
        this.localValue = []
        return
      }
      const updateVal = this.$props.options.filter((x: any) => newVal.includes(x['value']) || newVal.map((x: any) => x.value).includes(x['value']))
      if (this.$props.selectAll) {
        const allSelected = this.$props.options.length === newVal.length
        const newAllIndex = newVal.findIndex((it: any) => it.value === 'all')
        if (allSelected && newAllIndex === -1) {
          updateVal.push({
            key: 'all',
            value: 'all',
            content: 'All'
          })
        }
        if (!allSelected && newAllIndex > -1) {
          updateVal.splice(newAllIndex, 1)
        }
      }
      this.localValue = updateVal
    }, { immediate: true })
  }

  emitInput (e: any) {
    if (this.$props.selectAll) {
      const newAllIndex = e.findIndex((it: any) => it.value === 'all')
      const oldAllIndex = this.localValue.findIndex((it: any) => it.value === 'all')
      if (newAllIndex > -1 && oldAllIndex === -1) {
        e = this.localOptions
      }

      if (newAllIndex === -1 && oldAllIndex > -1) {
        e = []
      }

      this.$emit('input', e.filter((it: any) => it.value !== 'all').map((it: any) => it.value))
      return
    }

    this.$emit('input', e.map((it: any) => it.value))
  }

  removeItem (value: any) {
    this.localValue = this.localValue.filter((item: any) => item.value !== value)
    this.emitInput(this.localValue)
  }

  positionDropdown () {
    if (this.$props.appendToBody) {
      // @ts-ignore
      const el = this.$refs.multiselect.$el.querySelector('input').getBoundingClientRect()
      // @ts-ignore
      const $itemsList = this.$refs.multiselect.$el.querySelector('.multiselect__content')

      this.direction = window.screen.height - el.bottom < 240 ? 'top' : 'bottom'

      $itemsList.style.top = this.direction === 'top'
        ? `${el.top - 240 - 4}px`
        : `${el.top + el.height + 4}px`

      $itemsList.style.position = 'fixed'
      $itemsList.style.left = `${el.left}px`
      $itemsList.style.width = `${el.width}px`
    }
  }

  onOpen () {
    if (this.$props.appendToBody) {
      document.addEventListener('scroll', this.positionDropdown)
      this.positionDropdown()
    }
    // @ts-ignore
    this.$refs.multiselect.$el.querySelector('input').scrollIntoView({ block: 'nearest' })
    this.$emit('open')
  }

  onClose () {
    if (this.$props.appendToBody) {
      document.removeEventListener('scroll', this.positionDropdown)
    }
    this.$emit('close')
    this.$emit('focusout')
  }

  clear () {
    if (!this.$props.disabled) {
        this.$emit('input', [])
        this.$emit('close')
        this.$emit('focusout')
    }
  }
}
